import { getInitialState } from "../../utils";
import ActionTypes from "../actions/ActionTypes";
const initialState = {
  gigsSupportList: [],
  activeFilters: {},
  slotHistoryDetail: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_SLOT_HISTORY_DETAIL:
      return setSlotHistoryDetail(state, action);
    case ActionTypes.SET_GIGS_SUPPORT_LIST:
      return setGigsSupportList(state, action);
    case ActionTypes.SET_ACTIVE_FILTERS_GIGS_SUPPORT:
      return setActiveFilters(state, action);
    case ActionTypes.RESET_STATE_GIGS_SUPPORT:
      return resetGigsSupport(state, action);
    default:
      return state;
  }
}

const setGigsSupportList = (state, action) => {
  return {
    ...state,
    gigsSupportList: action.payload,
  };
};

const setSlotHistoryDetail = (state, action) => {
  return {
    ...state,
    slotHistoryDetail: action.payload,
  };
};

const resetGigsSupport = (state, action) => {
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
